import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";
import * as ReactQuery from "react-query";
import { UseQueryResult } from "react-query";
import axios from "axios";

import { DataSourceAddressAutocomplete_QueryKey } from "./data-source-address-autocomplete-query-key-factory";

export interface AddressAutocomplete_QueryResult {
  data?: string[];
  success?: boolean;
}

export interface DataSourceAddressAutocompleteQueryConsumerInterface {
  data: UseQueryResult<AddressAutocomplete_QueryResult>["data"];
  status: UseQueryResult<AddressAutocomplete_QueryResult>["status"];
}
const defaultValue =
  {} as unknown as DataSourceAddressAutocompleteQueryConsumerInterface;
const DataSourceAddressAutocompleteQueryContext =
  React.createContext(defaultValue);
const DataSourceAddressAutocompleteQueryContext_44 =
  React44ms.React.createContext(
    defaultValue,
    DataSourceAddressAutocompleteQueryContext
  );

export interface DataSourceAddressAutocompleteQueryProviderProps {
  addressToAutocomplete?: string;
  countryCode?: string;
}
export const DataSourceAddressAutocompleteQueryProvider: React.FunctionComponent<
  DataSourceAddressAutocompleteQueryProviderProps
> = (props) => {
  const queryKey = React.useMemo(() => {
    return DataSourceAddressAutocomplete_QueryKey.addressAutocomplete(props);
  }, [props, props.addressToAutocomplete, props.countryCode]);

  const queryFn: ReactQuery.QueryFunction<
    AddressAutocomplete_QueryResult,
    typeof queryKey
  > = async (context: ReactQuery.QueryFunctionContext<typeof queryKey>) => {
    const [baseQuery, desiredAddress] = context.queryKey;

    const { addressToAutocomplete, countryCode } = desiredAddress;

    if (
      (addressToAutocomplete || "").length < 1 ||
      (countryCode || "").length < 1
    ) {
      return {};
    }

    const { data: addressAutocomplete_queryResult } =
      await axios.get<AddressAutocomplete_QueryResult>(
        `/addressvalidation/address/search?address=${addressToAutocomplete}&country=${countryCode}`
      );

    return addressAutocomplete_queryResult;
  };

  const { status, data, ...result } = ReactQuery.useQuery(queryKey, queryFn, {
    refetchOnWindowFocus: false,
  });

  const value: DataSourceAddressAutocompleteQueryConsumerInterface =
    React.useMemo(
      () => ({
        status,
        data,
      }),
      [status, data]
    );

  return (
    <DataSourceAddressAutocompleteQueryContext.Provider value={value}>
      <DataSourceAddressAutocompleteQueryContext_44.Provider value={value}>
        {props?.children || []}
      </DataSourceAddressAutocompleteQueryContext_44.Provider>
    </DataSourceAddressAutocompleteQueryContext.Provider>
  );
};

export const useDataSourceAddressAutocompleteQuery = () => {
  const context = React.useContext(DataSourceAddressAutocompleteQueryContext);
  /**
   * Normally we do this pattern below for using any provider,
   * this here is a special case where
   * we want the defaultValue to be used when this provider isn't in the tree,
   * because it can be used when there is a fully formed request information packet,
   * which isn't guaranteed to be available immediately.
   */
  // if (context === defaultValue) {
  //   throw new Error(
  //     "useDataSourceAddressAutocompleteQuery must be used within a DataSourceAddressAutocompleteQueryProvider"
  //   );
  // }
  return context;
};

export const useDataSourceAddressAutocompleteQuery_44 = () => {
  const context = React44ms.React.useContext(
    DataSourceAddressAutocompleteQueryContext_44
  );
  /**
   * Normally we do this pattern below for using any provider,
   * this here is a special case where
   * we want the defaultValue to be used when this provider isn't in the tree,
   * because it can be used when there is a fully formed request information packet,
   * which isn't guaranteed to be available immediately.
   */
  // if (context === defaultValue) {
  //   throw new Error(
  //     "useDataSourceAddressAutocompleteQuery must be used within a DataSourceAddressAutocompleteQueryProvider"
  //   );
  // }
  return context;
};
